import React from "react";
// for page one

import ProjectPageOne from "./PageOne/Project.jsx";
import ContractDateDetails from "./PageOne/ContractDateDetails.jsx";
import ClientAndContractor from "./PageOne/ClientAndContractor.jsx";
import RestOne from "./PageOne/RestOne.jsx";

// for page two

import ProjectPageTwo from "./PageTwo/Project.jsx";
import Services from "./PageTwo/Services.jsx";
import BillingSchedules from "./PageTwo/BillingSchedules.jsx";

// for page three

import PageThree from "./PageThree/PageThree.jsx";

// for page four

import PageFour from "./PageFour/PageFour.jsx";

// for page five
import PageFive from "./PageFive/PageFive.jsx";

// for page six
import PageSix from "./PageSix/PageSix.jsx";

import TextStyles from "../../../../../Constants/TextStyles";
import Styled from "./ReviewStyles";
import ListAddClause from "./AddClause/ListAddClause";

const Review = (props) => {
  const selectedData = props && props.selectedData;
  const data = props && props.data;
  const businessInfoData = props && props.businessInfoData;

  return (
    <div className="px-md-4 px-sm-3 px-2">
        <div
          className="p-3 p-md-4 mx-auto bg-white"
          style={{ maxWidth: 800 }}
        >
          <Styled.ReviewBox className="mb-4">
              <TextStyles.FontSize22px className="fw-medium">
                Service Contract
              </TextStyles.FontSize22px>
              <ProjectPageOne selectedData={selectedData} />
              <ContractDateDetails selectedData={selectedData} />
              <ClientAndContractor
                selectedData={selectedData}
                data={data}
                businessInfoData={businessInfoData}
              />
              <RestOne
                selectedData={selectedData}
                data={data}
                businessInfoData={businessInfoData}
              />
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
            <div>
              <TextStyles.FontSize22px className="three-dots fw-medium">
                Attachment A : Services
              </TextStyles.FontSize22px>
              <ProjectPageTwo selectedData={selectedData} />
              <Services selectedData={selectedData} />
              <BillingSchedules selectedData={selectedData} />
            </div>
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
              <TextStyles.FontSize22px className="three-dots fw-medium">
                Attachment B : Terms and Conditions
              </TextStyles.FontSize22px>
              <PageThree selectedData={selectedData} />
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
              <PageFour selectedData={selectedData} />
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
              <PageFive selectedData={selectedData} />
          </Styled.ReviewBox>
          <Styled.ReviewBox className="mb-4">
              <PageSix selectedData={selectedData} />
          </Styled.ReviewBox>

          {selectedData &&
            selectedData.add_clause &&
            selectedData.add_clause.filter(clause => clause.required === true).length > 0 && (
              <Styled.ReviewBox className="d-flex flex-column gap-4">
                  {selectedData &&
                    selectedData.add_clause &&
                    selectedData.add_clause.map((data, index) => {
                      return <ListAddClause key={index} data={data} />;
                    })}
              </Styled.ReviewBox>
            )}
        </div>
      </div>
  );
};

export default Review;
